/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Organizationsettings_Slugpattern2Inputs */

const zh_organizationsettings_slugpattern2 = /** @type {(inputs: Organizationsettings_Slugpattern2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`标识只能包含小写字母、数字和连字符`)
};

const en_organizationsettings_slugpattern2 = /** @type {(inputs: Organizationsettings_Slugpattern2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Slug can only contain lowercase letters, numbers, and hyphens`)
};

const es_organizationsettings_slugpattern2 = /** @type {(inputs: Organizationsettings_Slugpattern2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El slug solo puede contener letras minúsculas, números y guiones`)
};

/**
* | output |
* | --- |
* | "Slug can only contain lowercase letters, numbers, and hyphens" |
*
* @param {Organizationsettings_Slugpattern2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const organizationsettings_slugpattern2 = /** @type {((inputs?: Organizationsettings_Slugpattern2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Organizationsettings_Slugpattern2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_organizationsettings_slugpattern2(inputs)
	if (locale === "en") return en_organizationsettings_slugpattern2(inputs)
	return es_organizationsettings_slugpattern2(inputs)
});
export { organizationsettings_slugpattern2 as "organizationSettings_slugPattern" }